import { AvatarContent } from './components/AvatarContent'
import { AvatarRoot } from './components/AvatarRoot'

export const Avatar = {
  Root: AvatarRoot,
  Content: AvatarContent,
}
